import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import {ga4SendOnce} from "../../function";

const UseDispatchState = ({state, reducer,event}) => {
    const dispatch = useDispatch();
    const getState = useSelector(state);

    const onClickDispatch = (data) => {
        if(event) {
            ga4SendOnce(event)
        }
        dispatch({
            type: reducer,
            data: data,
        })
    }


    return [getState,onClickDispatch]
};

export default UseDispatchState;